/* ============================================
   QUIZ FUNNEL — State Machine + Transitions
   ============================================ */

(function() {
  'use strict';

  const STEPS = ['gender', 'age', 'area', 'severity', 'edu1', 'emotional', 'tried', 'edu2', 'loading', 'results'];
  const PROGRESS = [0, 12, 25, 37, 50, 62, 75, 87, 95, 100];

  // --- Quiz Analytics App: session tracking ---
  var QUIZ_ANALYTICS_URL = 'https://quiz-funnel-analytics.fly.dev/api/quiz-event';

  function getOrCreateSessionId() {
    var sid = sessionStorage.getItem('fc_quiz_session_id');
    if (!sid) {
      sid = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
      sessionStorage.setItem('fc_quiz_session_id', sid);
    }
    return sid;
  }
  var QUIZ_SESSION_ID = getOrCreateSessionId();

  function getUtmParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || ''
    };
  }
  var UTM = getUtmParams();

  function postQuizEvent(eventType, stepName, stepIndex, answerValue) {
    if (!QUIZ_ANALYTICS_URL) return;
    var payload = JSON.stringify({
      session_id: QUIZ_SESSION_ID,
      shop: (window.Shopify && window.Shopify.shop) || 'follicleandco.myshopify.com',
      event_type: eventType,
      step_name: stepName,
      step_index: stepIndex,
      answer_value: answerValue || null,
      progress: PROGRESS[stepIndex] || 0,
      timestamp: new Date().toISOString(),
      user_agent: navigator.userAgent,
      referrer: document.referrer,
      utm_source: UTM.utm_source,
      utm_medium: UTM.utm_medium,
      utm_campaign: UTM.utm_campaign,
      quiz_variant: QUIZ_VARIANT,
      ad_variant: QUIZ_VARIANT,
      experiment_id: EXPERIMENT_ID
    });
    // Use text/plain to avoid CORS preflight — server parses JSON from text/plain body
    if (navigator.sendBeacon) {
      navigator.sendBeacon(QUIZ_ANALYTICS_URL, new Blob([payload], { type: 'text/plain' }));
    } else {
      fetch(QUIZ_ANALYTICS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: payload,
        keepalive: true
      }).catch(function() {});
    }
  }
  // --- A/B Variant Assignment (fetched from app API) ---
  var EXPERIMENT_CONFIG_URL = 'https://quiz-funnel-analytics.fly.dev/api/experiment-config';
  var EXPERIMENT_ID = null;
  // Default configs (control)
  var VARIANT_CONFIG = { a: { skipSteps: [] }, b: { skipSteps: [] } };
  var STEP_OVERRIDES = {};

  // Try to load experiment config from sessionStorage cache first
  try {
    var cached = sessionStorage.getItem('fc_experiment_config');
    if (cached) {
      var exp = JSON.parse(cached);
      if (exp.active) {
        EXPERIMENT_ID = exp.id;
        VARIANT_CONFIG.b = exp.quizConfig || { skipSteps: [] };
        STEP_OVERRIDES = exp.quizConfig && exp.quizConfig.stepOverrides ? exp.quizConfig.stepOverrides : {};
        // Store ad config for quiz-results.js to read
        sessionStorage.setItem('fc_ad_config', JSON.stringify(exp.adConfig || {}));
        sessionStorage.setItem('fc_experiment_traffic', String(exp.trafficPct || 50));
      }
    }
  } catch(e) {}

  // Fetch fresh config in background (non-blocking)
  if (EXPERIMENT_CONFIG_URL) {
    fetch(EXPERIMENT_CONFIG_URL).then(function(r) { return r.json(); }).then(function(exp) {
      sessionStorage.setItem('fc_experiment_config', JSON.stringify(exp));
      if (exp.active) {
        EXPERIMENT_ID = exp.id;
        VARIANT_CONFIG.b = exp.quizConfig || { skipSteps: [] };
        STEP_OVERRIDES = exp.quizConfig && exp.quizConfig.stepOverrides ? exp.quizConfig.stepOverrides : {};
        sessionStorage.setItem('fc_ad_config', JSON.stringify(exp.adConfig || {}));
        sessionStorage.setItem('fc_experiment_traffic', String(exp.trafficPct || 50));
      }
    }).catch(function() {});
  }

  function getVariant() {
    // Priority 1: URL param override
    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('v');
    if (urlVariant && (urlVariant === 'a' || urlVariant === 'b')) {
      sessionStorage.setItem('fc_quiz_variant', urlVariant);
      return urlVariant;
    }
    // Priority 2: Existing session assignment
    var stored = sessionStorage.getItem('fc_quiz_variant');
    if (stored && (stored === 'a' || stored === 'b')) return stored;
    // Priority 3: Random split based on experiment traffic %
    var trafficPct = parseInt(sessionStorage.getItem('fc_experiment_traffic') || '50', 10);
    var variant = (Math.random() * 100) < trafficPct ? 'b' : 'a';
    sessionStorage.setItem('fc_quiz_variant', variant);
    return variant;
  }
  var QUIZ_VARIANT = getVariant();
  var ACTIVE_CONFIG = VARIANT_CONFIG[QUIZ_VARIANT] || VARIANT_CONFIG.a;
  // --- End A/B Variant Assignment ---

  // --- End Quiz Analytics App ---

  const state = {
    current: 0,
    answers: {
      gender: null,
      age: null,
      area: null,
      severity: null,
      emotional: null,
      tried: []
    }
  };


  // DOM
  const progressFill = document.getElementById('quizProgressFill');
  const progressPct = document.getElementById('quizProgressPct');
  const stepLabel = document.getElementById('quizStepLabel');
  const steps = document.querySelectorAll('.quiz__step');
  const backBtn = document.getElementById('quizBack');
  const stepCount = document.getElementById('quizStepCount');

  // Analytics: track quiz step views and answers
  function trackStep(idx, fromIdx) {
    const stepName = STEPS[idx];
    const fromStepName = fromIdx != null ? STEPS[fromIdx] : 'entry';

    // Google Analytics 4 (gtag)
    if (typeof gtag === 'function') {
      gtag('event', 'quiz_step_view', {
        quiz_step: stepName,
        quiz_step_index: idx,
        quiz_from_step: fromStepName,
        quiz_progress: PROGRESS[idx]
      });
    }

    // Facebook Pixel
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'QuizStepView', {
        step: stepName,
        step_index: idx,
        from_step: fromStepName,
        progress: PROGRESS[idx]
      });
    }

    // Generic dataLayer push (works with GTM)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quiz_step_view',
      quiz_step: stepName,
      quiz_step_index: idx,
      quiz_from_step: fromStepName,
      quiz_progress: PROGRESS[idx],
      quiz_answers: JSON.parse(JSON.stringify(state.answers))
    });

    // Quiz Analytics App
    postQuizEvent('step_view', stepName, idx, null);
  }

  function trackAnswer(stepName, value) {
    if (typeof gtag === 'function') {
      gtag('event', 'quiz_answer', {
        quiz_step: stepName,
        quiz_answer: Array.isArray(value) ? value.join(',') : value
      });
    }

    if (typeof fbq === 'function') {
      fbq('trackCustom', 'QuizAnswer', {
        step: stepName,
        answer: Array.isArray(value) ? value.join(',') : value
      });
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quiz_answer',
      quiz_step: stepName,
      quiz_answer: Array.isArray(value) ? value.join(',') : value
    });

    // Quiz Analytics App
    postQuizEvent('answer', stepName, state.current, Array.isArray(value) ? value.join(',') : value);
  }

  function showStep(idx) {
    // A/B: skip steps defined in variant config
    if (ACTIVE_CONFIG.skipSteps && ACTIVE_CONFIG.skipSteps.indexOf(STEPS[idx]) >= 0) {
      // Determine direction: if going forward, advance; if going back, go further back
      var direction = idx > state.current ? 1 : -1;
      showStep(idx + direction);
      return;
    }

    var fromIdx = state.current;
    steps.forEach(s => s.classList.remove('active'));
    if (steps[idx]) {
      steps[idx].classList.add('active');
      // Re-trigger animation
      steps[idx].style.animation = 'none';
      steps[idx].offsetHeight; // reflow
      steps[idx].style.animation = '';
    }
    state.current = idx;

    // Fire analytics event
    trackStep(idx, fromIdx);

    // Update progress bar
    const pct = PROGRESS[idx];
    if (progressFill) {
      progressFill.style.width = pct + '%';
    }
    if (progressPct) {
      progressPct.textContent = pct + '%';
    }

    // Update step label
    const questionSteps = [0,1,2,3,5,6]; // actual question step indices
    const qIdx = questionSteps.indexOf(idx);
    if (stepLabel) {
      if (qIdx >= 0) {
        stepLabel.textContent = `Question ${qIdx + 1} of ${questionSteps.length}`;
      } else if (idx === 4 || idx === 7) {
        stepLabel.textContent = 'Quick insight';
      } else if (idx === 8) {
        stepLabel.textContent = 'Almost done...';
      } else if (idx === 9) {
        stepLabel.textContent = 'Your results';
      }
    }

    // Update old step count too (if still in DOM)
    if (stepCount) {
      if (qIdx >= 0) {
        stepCount.textContent = `Step ${qIdx + 1} of ${questionSteps.length}`;
      } else {
        stepCount.textContent = '';
      }
    }

    // Back button visibility
    if (backBtn) {
      backBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
    }

    // Handle edu1 personalized content
    if (STEPS[idx] === 'edu1') {
      populateEdu1();
    }

    // Handle loading step auto-advance
    if (STEPS[idx] === 'loading') {
      runLoadingAnimation();
    }

    // Handle edu2 conditional content
    if (STEPS[idx] === 'edu2') {
      populateEdu2();
    }

    // Handle results population
    if (STEPS[idx] === 'results') {
      populateResults();
    }

    // Scroll to top — use rAF to ensure DOM swap completes first
    requestAnimationFrame(function() {
      window.scrollTo({ top: 0, behavior: 'instant' });
    });

    // A/B: apply step content overrides for Variant B
    if (QUIZ_VARIANT === 'b' && STEP_OVERRIDES[STEPS[idx]]) {
      var ov = STEP_OVERRIDES[STEPS[idx]];
      var stepEl = steps[idx];
      if (stepEl) {
        if (ov.title) {
          var titleEl = stepEl.querySelector('.quiz__title');
          if (titleEl) titleEl.textContent = ov.title;
        }
        if (ov.subtitle) {
          var subtitleEl = stepEl.querySelector('.quiz__subtitle');
          if (subtitleEl) subtitleEl.textContent = ov.subtitle;
        }
        if (ov.options && ov.options.length) {
          var labelEls = stepEl.querySelectorAll('.quiz__option-label');
          for (var oi = 0; oi < ov.options.length && oi < labelEls.length; oi++) {
            if (ov.options[oi].label) {
              labelEls[oi].textContent = ov.options[oi].label;
            }
          }
        }
      }
    }
  }

  function goBack() {
    if (state.current > 0) {
      showStep(state.current - 1);
    }
  }

  // Single-select handler
  function handleSingleSelect(stepEl, answerKey) {
    const options = stepEl.querySelectorAll('.quiz__option:not(.quiz__option--multi)');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        // Deselect all
        options.forEach(o => o.classList.remove('selected'));
        // Select this
        opt.classList.add('selected');
        state.answers[answerKey] = opt.dataset.value;
        trackAnswer(answerKey, opt.dataset.value);
        // Auto-advance after brief delay
        setTimeout(() => {
          showStep(state.current + 1);
        }, 300);
      });
    });
  }

  // Multi-select handler
  function handleMultiSelect(stepEl, answerKey) {
    const options = stepEl.querySelectorAll('.quiz__option--multi');
    const continueBtn = stepEl.querySelector('.quiz__continue');

    options.forEach(opt => {
      opt.addEventListener('click', () => {
        opt.classList.toggle('selected');

        // Update state
        const selected = [];
        options.forEach(o => {
          if (o.classList.contains('selected')) selected.push(o.dataset.value);
        });
        state.answers[answerKey] = selected;
        trackAnswer(answerKey, selected);

        // Enable/disable continue
        if (continueBtn) {
          if (selected.length > 0) {
            continueBtn.classList.add('enabled');
          } else {
            continueBtn.classList.remove('enabled');
          }
        }
      });
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', () => {
        if (continueBtn.classList.contains('enabled')) {
          showStep(state.current + 1);
        }
      });
    }
  }

  // Continue button handler (for interstitials)
  function handleContinue(stepEl) {
    const btn = stepEl.querySelector('.quiz__continue');
    if (btn) {
      btn.classList.add('enabled');
      btn.addEventListener('click', () => {
        showStep(state.current + 1);
      });
    }
  }

  // Education #1 — personalized based on gender + age + area + severity
  function populateEdu1() {
    const { gender, age, area, severity } = state.answers;
    const container = document.getElementById('edu1Content');
    if (!container) return;

    const CDN = 'https://cdn.shopify.com/s/files/1/0998/3610/0740/files/';

    // 1. IMAGE per area
    const imgMap = {
      crown: CDN + 'edu1-crown.png',
      hairline: CDN + 'edu1-hairline.png',
      partline: CDN + 'edu1-partline.png',
      diffuse: CDN + 'edu1-diffuse.png',
      unsure: CDN + 'edu1-generic.png'
    };
    const imgSrc = imgMap[area] || imgMap.unsure;

    // 2. HEADLINE — Schwartz Identification: mirror their exact situation
    const headlines = {
      'male-crown': "Here\u2019s what\u2019s happening at your crown \u2014 and why nothing has worked",
      'male-hairline': "Here\u2019s why your hairline keeps receding \u2014 and what most treatments miss",
      'male-diffuse': "Here\u2019s why your hair is thinning everywhere \u2014 and why one-trick products fail",
      'female-partline': "Here\u2019s why your part line is widening \u2014 and what most products get wrong",
      'female-crown': "Here\u2019s what\u2019s causing your crown thinning \u2014 and why shampoos won\u2019t fix it",
      'female-diffuse': "Here\u2019s why diffuse thinning is hard to treat \u2014 and what actually works",
      'neutral-crown': "Here\u2019s what\u2019s happening beneath the surface \u2014 and why most treatments fail",
      'neutral-hairline': "Here\u2019s what\u2019s happening beneath the surface \u2014 and why most treatments fail",
      'neutral-partline': "Here\u2019s what\u2019s happening beneath the surface \u2014 and why most treatments fail",
      'neutral-diffuse': "Here\u2019s what\u2019s happening beneath the surface \u2014 and why most treatments fail"
    };
    const g = gender || 'neutral';
    const a = area || 'unsure';
    const headlineKey = g + '-' + a;
    const headline = headlines[headlineKey]
      || (a === 'unsure' ? "Here\u2019s why you\u2019re noticing changes \u2014 and what the science says" : headlines['neutral-crown']);

    // 3. AREA PARAGRAPH — Schwartz Gradualization: start with what they know, explain WHY
    // Written for Grade 6-7 readability: short sentences, active voice, no jargon without explanation
    const areaCopy = {
      crown: "Your crown has the highest concentration of DHT receptors on your scalp. DHT is a hormone that shrinks hair follicles over time. That\u2019s why the top of your head thins first. The follicles aren\u2019t dead. They\u2019re shrinking. But here\u2019s the problem: any serum you rub on top sits on a wall of dead skin cells. It never reaches the follicle. 95% of it evaporates.",
      hairline: "Your temples are the most sensitive part of your scalp. The follicles there react to DHT faster than anywhere else. That\u2019s why the hairline goes first. The follicles aren\u2019t gone. They\u2019re miniaturizing \u2014 producing thinner, shorter hairs each cycle. But topical serums can\u2019t reach them. A skin barrier blocks 95% of everything you apply.",
      partline: "A widening part line means follicles along your central scalp are shrinking. Each growth cycle produces thinner, weaker hairs. The scalp shows through more. This is driven by hormonal sensitivity and reduced blood flow to the area. Topical products sit on the surface and never reach these follicles. 95% of the active ingredients evaporate before doing anything.",
      diffuse: "Diffuse thinning is the hardest to treat. It\u2019s not one problem. It\u2019s several happening at once: DHT shrinking follicles, reduced blood flow, shortened growth cycles, and dormant stem cells. A product that targets just one of these won\u2019t be enough. And any product applied to the surface loses 95% to the skin barrier.",
      unsure: "If you\u2019re noticing changes but not sure exactly where, that\u2019s actually good. It means you\u2019re early. The earlier you act, the more follicles are still alive and can be reactivated. Right now, most of your thinning follicles are dormant \u2014 not dead. But every month you wait, more of them shrink past the point of return."
    };

    // 4. AGE CONTEXT — one sentence, adds personal relevance
    const ageCopy = {
      'under25': "At your age, your follicles have had less time to shrink. Early action gives you the best odds.",
      '25-34': "In your late 20s and 30s, DHT damage accelerates. The follicles you save now determine your density for the next decade.",
      '35-44': "By your 40s, years of cumulative damage add up. But dormant follicles can still respond to the right treatment.",
      '45-54': "At this stage, it\u2019s about maximizing what\u2019s still viable. Multi-pathway formulas preserve and reactivate existing follicles better than single-ingredient products.",
      '55+': "Follicle biology doesn\u2019t stop at any age. Published studies show reactivation is possible with clinical-grade compounds delivered intradermally."
    };

    // 5. SEVERITY BLOCK — Schwartz Intensification: match urgency to their reality
    const sevCopy = {
      mild: '<strong>Good news: you caught this early.</strong> Most of your thinning follicles are dormant, not dead. They can be reactivated. A maintenance protocol \u2014 one session every 10 days \u2014 is usually enough at this stage.',
      moderate: '<strong>Your follicles are actively shrinking.</strong> Each growth cycle produces thinner hairs. But the follicles are still alive. A 3-month corrective protocol gives the formula enough time to restart the growth cycle and reverse miniaturization.',
      advanced: '<strong>Let\u2019s be honest about where you are.</strong> Some follicles may have fully miniaturized. The ones that are dormant can still be reactivated. A 6-month protocol gives the best chance. We offer a 90-day money-back guarantee if you don\u2019t see progress.'
    };

    // 6. PATHWAY EMPHASIS — based on area, explains HOW our formula addresses their specific issue
    const pathwayCopy = {
      crown: '<strong>Redensyl 3.0%</strong> targets dormant stem cells at the crown. In clinical studies, it produced +17% new growth-phase hairs in 84 days. Delivered via microneedle \u2014 not sitting on the surface.',
      hairline: '<strong>Procapil 2.5% + Capixyl 2.5%</strong> block DHT right at the follicle. No pills. No systemic side effects. Clinical data shows +121% growth rate improvement in 4 months. Microneedle delivery gets it past the barrier to the temple follicles.',
      partline: '<strong>GHK-Cu</strong> triggers growth factor signaling along the central scalp, while <strong>Caffeine + Arginine</strong> increase blood flow to the part line area. 6 pathways working together where you need them most.',
      diffuse: 'This is exactly why we built a <strong>6-pathway system</strong>. DHT modulation + stem cell activation + growth factors + anagen prolongation + anti-testosterone + blood flow. <strong>12% active load</strong> targeting every mechanism at once.',
      unsure: 'Our formula covers <strong>all 6 biological pathways</strong>. Wherever thinning develops, every mechanism is addressed. <strong>12% active load</strong> delivered directly past the barrier \u2014 no guessing required.'
    };

    // 7. STATS — personalized labels
    const areaLabel = {
      crown: 'targeting your crown follicles',
      hairline: 'targeting your hairline follicles',
      partline: 'targeting your part line',
      diffuse: 'targeting all thinning zones',
      unsure: 'across 6 biological pathways'
    };

    // BUILD HTML
    container.innerHTML = `
      <h2 class="quiz__title">${headline}</h2>
      <div class="quiz__interstitial-content">
        <div class="quiz__interstitial-image">
          <img src="${imgSrc}" alt="Personalized hair science diagram" loading="lazy" width="600" height="400">
        </div>
        <div class="quiz__interstitial-text" style="text-align:left;">
          <p>${areaCopy[a] || areaCopy.unsure}</p>
          <p style="color:var(--color-accent);font-weight:500;font-size:0.875rem;">${ageCopy[age] || ''}</p>
        </div>
        <div class="quiz__severity-card">
          <p>${sevCopy[severity] || sevCopy.moderate}</p>
        </div>
        <div class="quiz__pathway-card">
          <p>${pathwayCopy[a] || pathwayCopy.unsure}</p>
        </div>
        <div class="quiz__interstitial-stats">
          <div class="quiz__interstitial-stat">
            <span class="quiz__interstitial-stat-num">12%</span>
            <span class="quiz__interstitial-stat-label">${areaLabel[a] || 'active formula strength'}</span>
          </div>
          <div class="quiz__interstitial-stat">
            <span class="quiz__interstitial-stat-num">95%</span>
            <span class="quiz__interstitial-stat-label">of serum wasted without microneedle delivery</span>
          </div>
        </div>
      </div>
    `;
  }

  // Education #2 — conditional content
  function populateEdu2() {
    const tried = state.answers.tried || [];
    const container = document.getElementById('edu2Content');
    if (!container) return;

    let title = 'This is why most products plateau';
    let body = '';

    if (tried.includes('minoxidil')) {
      body = '<strong>Minoxidil targets 1 of 6 biological pathways</strong> — blood flow. That\'s it. It doesn\'t address DHT, stem cell dormancy, growth factor depletion, or testosterone suppression. That\'s why it plateaus after a few months. Our system targets all 6 pathways simultaneously with published peptide concentrations. Plus, Minoxidil has roughly 2% active load. Ours has 12% across 6 pathways — delivered directly past the barrier.';
    } else if (tried.includes('finasteride')) {
      body = '<strong>Finasteride blocks DHT systemically</strong> — one pathway, with known side effects. Our formula blocks DHT locally at the follicle using Procapil and Capixyl — no systemic exposure, no hormonal disruption. Plus 5 additional pathways that Finasteride doesn\'t touch. Our formula delivers 12% active load across 6 pathways — including DHT modulation — without systemic side effects.';
    } else if (tried.includes('supplements')) {
      body = '<strong>Oral biotin supports keratin production</strong> — but it can\'t reach the dermal papilla where follicle stem cells actually live. You can\'t grow new hair by swallowing a pill. Our microneedle system delivers 12% active peptides directly to the follicle, 3-4mm below the surface. And even if they could reach the follicle, most supplements target a single pathway. Our formula targets 6 simultaneously with 12% active load.';
    } else if (tried.includes('serums')) {
      body = '<strong>95% of your $40 serum evaporated on the surface.</strong> The stratum corneum — a wall of dead skin cells — blocks topical delivery. The active ingredients oxidized before reaching the follicle. Our 0.5mm titanium microneedles bypass this barrier entirely, delivering 100% of the formula to the target. And even the 5% that gets through? Most serums are 1-3% active ingredients. Ours is 12% — delivered directly where it works.';
    } else if (tried.includes('clinics')) {
      body = '<strong>Professional microneedling works.</strong> The science is proven. But at $300-500 per session, 2-4 times per month, it costs $1,800-3,000 over 6 months. Our system uses the same delivery principle — 0.5mm titanium microneedles — with a clinical-grade formula at 1/7th the cost. At home. In 5 minutes. Our formula matches clinical-grade concentrations — 12% active load, the same RCP trio used in professional settings.';
    } else {
      body = '<strong>You\'re early enough to make a real difference.</strong> The sooner you intervene, the more follicles are still in the dormant (not dead) phase and can be reactivated. Our microneedle system delivers 6 active pathways directly to the follicle at published clinical concentrations — 12% total active load vs the industry average of 1-3%.';
    }

    container.innerHTML = `
      <p class="quiz__interstitial-title">${title}</p>
      <p class="quiz__interstitial-body">${body}</p>
      <div class="quiz__interstitial-stat">
        <span class="quiz__interstitial-stat-num">12%</span>
        <span class="quiz__interstitial-stat-label">Our active load vs. 1-3% industry average</span>
      </div>
    `;
  }

  // Loading animation
  function runLoadingAnimation() {
    const items = document.querySelectorAll('#quizLoading .quiz__loading-item');
    items.forEach(item => item.classList.remove('done'));

    let i = 0;
    const interval = setInterval(() => {
      if (i < items.length) {
        items[i].classList.add('done');
        i++;
      } else {
        clearInterval(interval);
        setTimeout(() => showStep(state.current + 1), 800);
      }
    }, 1200);
  }

  // Populate results summary
  function populateResults() {
    const { gender, age, area, severity } = state.answers;
    const g = gender || 'neutral';
    const a = area || 'unsure';

    const areaMap = { hairline: 'Hairline / Temples', crown: 'Crown / Vertex', partline: 'Part Line', diffuse: 'Diffuse / All Over', unsure: 'General Thinning' };
    const sevMap = { mild: 'Mild', moderate: 'Moderate', advanced: 'Advanced' };

    const CDN = 'https://cdn.shopify.com/s/files/1/0998/3610/0740/files/';
    const now = new Date();
    const targetMonth = new Date(now.getFullYear(), now.getMonth() + 3, 1);
    const monthName = targetMonth.toLocaleString('default', { month: 'long', year: 'numeric' });

    const el = (id) => document.getElementById(id);
    if (el('resArea')) el('resArea').textContent = areaMap[a] || 'Not specified';
    if (el('resSeverity')) el('resSeverity').textContent = sevMap[severity] || 'Not specified';
    if (el('resSupply')) el('resSupply').textContent = '6-Month Protocol';
    if (el('resTimeline')) el('resTimeline').textContent = 'Expect visible improvement by ' + monthName;

    // Area-specific image
    const imgMap = {
      crown: CDN + 'edu1-crown.png',
      hairline: CDN + 'edu1-hairline.png',
      partline: CDN + 'edu1-partline.png',
      diffuse: CDN + 'edu1-diffuse.png',
      unsure: CDN + 'edu1-generic.png'
    };
    if (el('resImage')) el('resImage').src = imgMap[a] || imgMap.unsure;

    // --- Personalized email capture ---
    const titleMap = {
      'male-crown': 'Your crown regrowth protocol is ready.',
      'male-hairline': 'Your hairline recovery protocol is ready.',
      'male-diffuse': 'Your full-scalp protocol is ready.',
      'male-partline': 'Your protocol is ready.',
      'male-unsure': 'Your personalized starter protocol is ready.',
      'female-partline': 'Your part line protocol is ready.',
      'female-crown': 'Your crown thinning protocol is ready.',
      'female-diffuse': 'Your full-scalp protocol is ready.',
      'female-hairline': 'Your hairline protocol is ready.',
      'female-unsure': 'Your personalized starter protocol is ready.',
      'neutral-crown': 'Your crown protocol is ready.',
      'neutral-hairline': 'Your hairline protocol is ready.',
      'neutral-partline': 'Your part line protocol is ready.',
      'neutral-diffuse': 'Your full-scalp protocol is ready.',
      'neutral-unsure': 'Your personalized starter protocol is ready.'
    };

    const ageOpener = {
      'under25': "You\u2019re in your early 20s \u2014 early intervention has the highest success rate.",
      '25-34': "In your late 20s to 30s, follicles are still highly responsive to treatment.",
      '35-44': "In your 40s, timing matters \u2014 but your follicles can still respond.",
      '45-54': "In your 50s, a targeted multi-pathway approach makes the biggest difference.",
      '55+': "At any age, clinical-grade compounds can reactivate dormant follicles."
    };

    // Build protocol description from gender + age + area
    function buildProtocolDesc(g, age, a) {
      const genderLabel = { male: 'men', female: 'women', neutral: 'people' };
      const gLabel = genderLabel[g] || 'people';
      const ageLabel = {
        'under25': 'in their early 20s',
        '25-34': 'in their late 20s to 30s',
        '35-44': 'in their 40s',
        '45-54': 'in their 50s',
        '55+': 'over 55'
      };
      const aLabel = ageLabel[age] || '';
      const areaDetail = {
        crown: { name: 'crown thinning', target: 'targeting stem cell reactivation and DHT reduction at the vertex' },
        hairline: { name: 'hairline recession', target: 'focused on DHT modulation and follicle anchoring at the temples' },
        partline: { name: 'part line widening', target: 'addressing blood flow restoration and growth factor activation along the central scalp' },
        diffuse: { name: 'diffuse thinning', target: 'activating all 6 biological pathways simultaneously across the full scalp' },
        unsure: { name: 'early-stage thinning', target: 'covering all 6 pathways as a preventive protocol' }
      };
      const detail = areaDetail[a] || areaDetail.unsure;
      return 'We built this protocol specifically for ' + gLabel + ' ' + aLabel + ' experiencing ' + detail.name + ' \u2014 ' + detail.target + '. It includes your recommended schedule, targeted pathways, and month-by-month milestones.';
    }

    const sevFrame = {
      mild: "Since you caught this early, your protocol focuses on maintenance and protection.",
      moderate: "This is a corrective protocol \u2014 designed to reverse follicle miniaturization over 6 months.",
      advanced: "This is our most intensive protocol \u2014 maximum frequency, full pathway activation, honest timeline."
    };

    const emailTitle = titleMap[g + '-' + a] || 'Your personalized protocol is ready.';
    const emailSub = (ageOpener[age] || '') + ' ' + buildProtocolDesc(g, age, a) + ' ' + (sevFrame[severity] || sevFrame.moderate);

    if (el('emailTitle')) el('emailTitle').textContent = emailTitle;
    if (el('emailSubtitle')) el('emailSubtitle').textContent = emailSub.trim();
  }

  // Build URL params and navigate to results
  function goToResults() {
    const p = new URLSearchParams();
    if (state.answers.gender) p.set('g', state.answers.gender);
    if (state.answers.age) p.set('age', state.answers.age);
    if (state.answers.area) p.set('area', state.answers.area);
    if (state.answers.severity) p.set('sev', state.answers.severity);
    if (state.answers.tried.length) p.set('tried', state.answers.tried.join(','));
    p.set('v', QUIZ_VARIANT);

    // Persist quiz answers for product page personalization
    try {
      localStorage.setItem('fc_quiz', JSON.stringify({
        g: state.answers.gender,
        age: state.answers.age,
        area: state.answers.area,
        sev: state.answers.severity
      }));
    } catch(e) {}

    // Quiz Analytics App: completion event
    postQuizEvent('completion', 'results', 9, null);

    // Variant B may route to a different results page
    var resultUrl = '/products/micro-infusion-system';
    if (QUIZ_VARIANT === 'b') {
      try {
        var adCfg = JSON.parse(sessionStorage.getItem('fc_ad_config') || '{}');
        if (adCfg.resultPageUrl) resultUrl = adCfg.resultPageUrl;
      } catch(e) {}
    }
    window.location.href = resultUrl + '?' + p.toString();
  }

  // Email form
  function setupEmailForm() {
    const form = document.getElementById('quizEmailForm');
    const skipLink = document.getElementById('quizEmailSkip');

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]').value;
        if (email) {
          // 1. Shopify contact form (backup)
          fetch('/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
              'form_type': 'customer',
              'utf8': '✓',
              'contact[email]': email,
              'contact[tags]': 'quiz-lead',
              'contact[note]': JSON.stringify(state.answers)
            })
          }).catch(() => {});

          // 2. Klaviyo — subscribe to Newsletter list + fire Completed Quiz event (flow trigger)
          try {
            var triedValue = Array.isArray(state.answers.tried) ? state.answers.tried.join(',') : (state.answers.tried || '');
            var quizGender = state.answers.gender || '';
            var quizAge = state.answers.age || '';
            var quizArea = state.answers.area || '';
            var quizSeverity = state.answers.severity || '';
            var quizEmotional = state.answers.emotional || '';

            var profileProperties = {
              Quiz_Gender: quizGender,
              Quiz_Age: quizAge,
              Quiz_Area: quizArea,
              Quiz_Severity: quizSeverity,
              Quiz_Emotional: quizEmotional,
              Quiz_Tried: triedValue,
              Quiz_Completed_At: new Date().toISOString(),
              Quiz_Session_Id: QUIZ_SESSION_ID,
              Quiz_Variant: QUIZ_VARIANT,
              Signup_Source: 'quiz'
            };

            // 2a. Subscribe profile to Newsletter list (UcEuDC) via Client Subscriptions API.
            //     Creates or updates the Klaviyo profile with quiz properties and opts them
            //     into marketing. US-only audience, single opt-in, implied consent via form submit.
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UpVZuV', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'revision': '2024-10-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Quiz Funnel',
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email,
                          properties: profileProperties
                        }
                      }
                    }
                  },
                  relationships: {
                    list: { data: { type: 'list', id: 'UcEuDC' } }
                  }
                }
              })
            }).catch(function(err) {
              console.warn('Klaviyo subscribe failed:', err);
            });

            // 2b. Fire Completed Quiz event. This is what the Klaviyo welcome flow triggers on —
            //     all profile properties are available for email personalization.
            if (window.klaviyo && typeof window.klaviyo.track === 'function') {
              window.klaviyo.track('Completed Quiz', profileProperties);
            } else if (window.klaviyo && typeof window.klaviyo.push === 'function') {
              window.klaviyo.push(['track', 'Completed Quiz', profileProperties]);
            }
          } catch(klaviyoErr) {
            console.warn('Klaviyo capture failed:', klaviyoErr);
          }
        }
        trackAnswer('email', 'submitted');
        postQuizEvent('email_capture', 'results', 9, email);
        goToResults();
      });
    }

    if (skipLink) {
      skipLink.addEventListener('click', (e) => {
        e.preventDefault();
        trackAnswer('email', 'skipped');
        postQuizEvent('email_skip', 'results', 9, null);
        goToResults();
      });
    }
  }

  // Init
  function init() {
    if (!steps.length) return;

    // Back button
    if (backBtn) backBtn.addEventListener('click', goBack);

    // Wire up each step
    steps.forEach((stepEl, idx) => {
      const stepName = STEPS[idx];

      switch(stepName) {
        case 'gender':
        case 'age':
        case 'area':
        case 'severity':
        case 'emotional':
          handleSingleSelect(stepEl, stepName);
          break;
        case 'tried':
          handleMultiSelect(stepEl, 'tried');
          break;
        case 'edu1':
        case 'edu2':
          handleContinue(stepEl);
          break;
        // loading and results are handled by auto-advance and email form
      }
    });

    setupEmailForm();
    showStep(0);
  }

  // Start when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
